import { teachersRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const teachersRouteMetadata: IRouteMetadataObj<typeof teachersRoutesObj> = {
  create: {
    title: "users.teacher.create.title",
    description: "users.teacher.create.description",
    lazy: () => import("@/pages/userManagement/teachers/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "users.teacher.edit.title",
    description: "users.teacher.edit.description",
    lazy: () => import("@/pages/userManagement/teachers/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
};

export const teachersRoutes = createRoute<typeof teachersRoutesObj>(
  teachersRoutesObj,
  teachersRouteMetadata,
);
